<template>
  <div class="animated fadeIn">
    <template v-if="socialDataLoaded">

      <template v-if="topMentioned.length > 0">

        <!-- Top Row -->
        <div class="card-deck mb-3">


          <b-card :no-body="true">
            <b-card-body class="p-3 clearfix">
              <div class="text-muted text-uppercase font-weight-bold font-s">Most Mentioned Teammates</div>

              <b-table class="mb-0 table-striped" responsive="sm" hover :items="topMentioned" :fields="topMentionedFields" head-variant="light">

                <div slot="avatar" class="avatar" slot-scope="item">
                  <img :src="item.value.url" class="img-avatar" alt="">
                  
                </div>
                <div slot="teammate" slot-scope="item">
                  <div>
                    <router-link :to="'/details/teammate?uid=' + item.item.slackId" class="unstyled-link">
                      {{item.value}}
                    </router-link>
                  </div>
                </div>
                <div slot="mentions" slot-scope="item">
                  <div class="clearfix">
                    <div class="float-left">
                      <strong>{{item.value}}</strong>
                    </div>
                  </div>
                  <b-progress height={} class="progress-xs" v-model="item.value" :max="topMentionedMostMentions"></b-progress>
                </div>

              </b-table>
            </b-card-body>
          </b-card>

          <b-card :no-body="true">
            <b-card-body class="p-3 clearfix">
              <div class="text-muted text-uppercase font-weight-bold font-s">Top {{ topChannelsByMentioned.length }} Channels By # of Mentions</div>

              <top-channels-chart 
                :chart-data="topChannelsByMentioned"
                :channel-data="teamChannels"
                :label="'Top Channels By Mentions'"
                :data-key="'mentions'"
                class="chart-wrapper" 
                style="min-height: 240px; height:88%; margin-top:10px;"/>
                
            </b-card-body>
          </b-card>

          <b-card :no-body="true">
            <b-card-body class="p-3 clearfix">
              <div class="text-muted text-uppercase font-weight-bold font-s">Top Information Seekers</div>

              <b-table class="mb-0 table-striped" responsive="sm" hover :items="topMentioners" :fields="topMentionersFields" head-variant="light">

                <div slot="avatar" class="avatar" slot-scope="item">
                  <img :src="item.value.url" class="img-avatar" alt="">
                  
                </div>
                <div slot="teammate" slot-scope="item">
                  <div>
                    <router-link :to="'/details/teammate?uid=' + item.item.slackId" class="unstyled-link">
                      {{item.value}}
                    </router-link>
                  </div>
                </div>
                <div slot="mentions" slot-scope="item">
                  <div class="clearfix">
                    <div class="float-left">
                      <strong>{{item.value}}</strong>
                    </div>
                  </div>
                  <b-progress height={} class="progress-xs" v-model="item.value" :max="topMentionersMostMentions"></b-progress>
                </div>

              </b-table>
            </b-card-body>
          </b-card>

        </div>

        <!-- Main area -->
        <b-card>
          <b-row>
            <b-col sm="5">
              <h4 id="message-activity" class="card-title mb-0">Teammate Mentions Breakdown by Channel</h4>
              <div class="small text-muted">{{ periodStartDay }} - {{ currentDay }}</div>
            </b-col>
            <b-col sm="7" class="d-none d-md-block">
              

            </b-col>
          </b-row>

          <channel-mentions-chart
            :chart-data="socialData.channels_mentions"
            :user-data="teamMembers"
            :channel-data="teamChannels"
            class="chart-wrapper" 
            :style="'margin-top:40px; height:' + socialChartHeight + 'px;'" 
            :height="Object.keys(socialData.channels_mentions).length * 60 + 80" />
        </b-card>
      </template>
      <template v-else>
        <b-card>
          <div style="color: #2f353a;">
            <h2>Social Analysis Dashboard</h2>
            <p>
              No teammates have mentioned each other in the selected time window.  Try expanding the time window, or check back later! 
            </p>
          </div>
          
        </b-card>
      </template>

    </template>
    <template v-else>
      <div class="sk-folding-cube align-middle">
        <div class="sk-cube1 sk-cube"></div>
        <div class="sk-cube2 sk-cube"></div>
        <div class="sk-cube4 sk-cube"></div>
        <div class="sk-cube3 sk-cube"></div>
      </div>
    </template>

  </div>
</template>


<script>
import { mapGetters, mapActions } from 'vuex'
import moment from 'moment'
import TopChannelsChart from './messaging/TopChannelsChart'
import ChannelMentionsChart from './social/ChannelMentionsChart'

export default {
  name: 'SocialDashboard',
  components: {
    TopChannelsChart,
    ChannelMentionsChart
  },
  data: function () {
    return {
      pageName: 'social',
      currentDay: moment().format('MMMM Do'),

      periodStartDay: moment().subtract(1, 'd').format('MMMM Do'),

      topMentionedFields: {
        avatar: {
          label: '', //'<i class="icon-people"></i>',
          class: 'text-center'
        },
        teammate: {
          label: 'Teammate'
        },
        mentions: {
          label: '# Mentions'
        }
      },
      topMentionersFields: {
        avatar: {
          label: '', //'<i class="icon-people"></i>',
          class: 'text-center'
        },
        teammate: {
          label: 'Teammate'
        },
        mentions: {
          label: '# of @s'
        }
      },
    }
    
  },

  watch: {
    timePeriod: function(period, lastPeriod) {
      if(this.$store.getters.currentPage === this.pageName) {
        this.fetchSocialData(period)
      }
    },
    filterUserIds: function(userIds, lastUserIds) {
      this.fetchSocialData(this.timePeriod)
    }
  },

  computed: {
    timePeriod() {
      let p = this.$store.getters.timePeriod
      return p
    },
    filterUserIds() {
      return this.$store.getters.filterUserIds
    },
    teamMembers() {
      return this.$store.getters.teamMembers
    },
    teamChannels() {
      return this.$store.getters.teamChannels
    },

    socialData() {
      return this.$store.getters.socialData
    },
    socialDataLoaded() {
      return this.$store.getters.socialDataLoaded
    },

    topChannelsByMentioned() {
      return this.socialData.top_channels_by_mentioned
    },
    topMentioned() {
      let mentioned = this.socialData.top_mentioned
      let formattedMentioned = []
      for (const m of mentioned) {
        let user = this.$store.getters.teamMember(m.user_id)
        let status = ''
        formattedMentioned.push({
          avatar: {url: user.avatar, status: status},
          teammate: user.real_name,
          slackId: user.slack_id,
          mentions: m.mentions
        })
      }
      return formattedMentioned
    },
    topMentionedMostMentions() {
      let mentioned = this.socialData.top_mentioned
      if(mentioned.length > 0) {
        return mentioned[0].mentions
      }
      return 100
    },
    topMentioners() {
      let mentioned = this.socialData.top_mentioners
      let formattedMentioners = []
      for (const m of mentioned) {
        let user = this.$store.getters.teamMember(m.user_id)
        let status = ''
        formattedMentioners.push({
          avatar: {url: user.avatar, status: status},
          teammate: user.real_name,
          slackId: user.slack_id,
          mentions: m.mentions
        })
      }
      return formattedMentioners
    },
    topMentionersMostMentions() {
      let mentioners = this.socialData.top_mentioners
      if(mentioners.length > 0) {
        return mentioners[0].mentions
      }
      return 100
    },

    socialChartHeight() {
      let n = Object.keys(this.socialData.channels_mentions).length

      if(n == 1) {
        return 140
      } else if(n < 5) {
        return 90 * n
      } else if(n < 10) {
        return 72 * n
      } else {
        return 60 * n
      }
    }
  },
  
  methods: {
    fetchSocialData: function(period) {
      this.$store.dispatch('updateSocialData', [period, this.filterUserIds])

      if(period == '6h') {
        this.periodStartDay = moment().subtract(6, 'h').format('MMMM Do')
      } else if(period == '12h') {
        this.periodStartDay = moment().subtract(12, 'h').format('MMMM Do')
      } else if(period == 'Day') {
        this.periodStartDay = moment().subtract(1, 'd').format('MMMM Do')
      } else if(period == 'Week') {
        this.periodStartDay = moment().subtract(7, 'd').format('MMMM Do')
      } else if(period == '2Weeks') {
        this.periodStartDay = moment().subtract(14, 'd').format('MMMM Do')
      } else if(period == 'Month') {
        this.periodStartDay = moment().subtract(30, 'd').format('MMMM Do')
      }
    }
  },

  mounted() {
    this.$store.commit('currentPage', this.pageName)
    this.fetchSocialData(this.timePeriod)
  }
}
</script>
